import {
  Address,
  AddressFailure,
  AddressRepository,
  Either,
  left,
  right,
} from "../../domain";
import { AddressRemoteDataSourceError } from "../core";
import { AddressRemoteDataSource } from "../data-sources";

export class AddressRepositoryImpl implements AddressRepository {
  constructor(readonly remoteDataSource: AddressRemoteDataSource) {}

  private handleError(error: Error): AddressFailure {
    const message = error.message as AddressRemoteDataSourceError;
    if (message === "NetworkError") return AddressFailure.networkFailure();
    return AddressFailure.serverFailure();
  }

  public async get(): Promise<Either<AddressFailure, Address[]>> {
    try {
      const res = await this.remoteDataSource.list();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async add(
    state: string,
    city: string,
    address: string,
    zipCode?: string
  ): Promise<Either<AddressFailure, null>> {
    try {
      const res = await this.remoteDataSource.add(
        state,
        city,
        address,
        zipCode
      );
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async edit(
    id: number,
    state?: string,
    city?: string,
    address?: string,
    zipCode?: string
  ): Promise<Either<AddressFailure, null>> {
    try {
      const res = await this.remoteDataSource.edit(
        id,
        state,
        city,
        address,
        zipCode
      );
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async delete(id: number): Promise<Either<AddressFailure, null>> {
    try {
      const res = await this.remoteDataSource.remove(id);
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }
}
